import { render, staticRenderFns } from "./LoaderMain.vue?vue&type=template&id=bba8cfc8&scoped=true&"
import script from "./LoaderMain.vue?vue&type=script&lang=js&"
export * from "./LoaderMain.vue?vue&type=script&lang=js&"
import style0 from "./LoaderMain.vue?vue&type=style&index=0&id=bba8cfc8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba8cfc8",
  null
  
)

export default component.exports